interface DashboardIconStaticProps {
  width?: number;
  height?: number;
  className?: string;
  color?: string;
  strokeWidth?: number;
}

export const DashboardIconStatic = ({
  width = 107,
  height = 107,
  className,
  color = "currentColor",
  strokeWidth = 8
}: DashboardIconStaticProps) => {
  // Normal state values (same as animated icon's normal state)
  const normalY = 8.82813;
  const normalHLine1 = 38.6099;
  const normalHLine2 = 68.3916;

  // Build paths for normal state
  const buildMainPath = (y: number) => {
    return `M53.5087 ${y}L78.76 ${y}C89.4852 ${y} 98.1797 ${y + 8.7025} 98.1797 ${y + 19.4277}L98.1797 ${y + 69.9342}C98.1797 ${y + 80.6593} 89.4852 ${y + 89.3538} 78.76 ${y + 89.3538}L53.5184 ${y + 89.3538}M53.5087 ${y}L28.2535 ${y}C17.5284 ${y} 8.83391 ${y + 8.7025} 8.83391 ${y + 19.4277}L8.83391 ${y + 69.9342}C8.83391 ${y + 80.6593} 17.5284 ${y + 89.3538} 28.2535 ${y + 89.3538}H53.5184M53.5087 ${y}L53.5184 ${y + 89.3538}`;
  };

  const buildHLine = (y: number) => `M8.83501 ${y}L53.5195 ${y}`;

  const mainPath = buildMainPath(normalY);
  const line1 = buildHLine(normalHLine1);
  const line2 = buildHLine(normalHLine2);

  return (
    <div className={className} style={{ width, height }}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 107 107"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d={mainPath}
          stroke={color}
          strokeWidth={strokeWidth}
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        <path
          d={line1}
          stroke={color}
          strokeWidth={strokeWidth}
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        <path
          d={line2}
          stroke={color}
          strokeWidth={strokeWidth}
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};
